export * from './use-global-content';
